import { sortBy } from 'lodash';
import { Router } from '@angular/router';
import { Browser } from '@capacitor/browser';
import { combineLatest, of, switchMap } from 'rxjs';
import { ChangeDetectorRef, Component } from '@angular/core';

import { TargetType, LoyaltySettingsType, ReputationWithoutTargetType, WalletWithReputationDtoType } from '@sifca-monorepo/widget-generator';
import { MobileReputationService, MobileAuthService } from '@sifca-monorepo/clients';

import { reputationPicture } from '../../environments/environment';
import { Platform } from '@ionic/angular';

@Component({
  template: '',
})
export class MobilePartnerComponent {
  isIos: boolean;
  isLinked: boolean;
  isFinalLevel: boolean;
  selectedPartner: TargetType;
  currentLevelPercentage: number;
  loyaltySettings: LoyaltySettingsType;
  reputationPicture = reputationPicture;
  nextLevel: ReputationWithoutTargetType;
  currentLevel: ReputationWithoutTargetType;
  reputationWallet: WalletWithReputationDtoType;
  quantitativeWallet$ = this.reputationService.quantitativeWallet$;

  constructor(
    protected platform: Platform,
    protected router: Router,
    protected cd: ChangeDetectorRef,
    protected authService: MobileAuthService,
    protected reputationService: MobileReputationService,
  ) {
    this.isIos = this.platform.is('ios');
    const nav = this.router.getCurrentNavigation();
    this.selectedPartner = nav?.extras?.state?.partner;
    this.authService
      .linkUserAccountForAggregator(this.selectedPartner?.pos?.id)
      .pipe(
        switchMap((res) => {
          localStorage.setItem('userToken', res.accessToken);
          return combineLatest([
            this.reputationService.getUserWalletWithReputations(),
            this.reputationService.findLoyaltySettingsByTargetOrAggregator(this.selectedPartner?.pos?.id),
          ]);
        }),
        switchMap(([result, res]) => {
          this.isLinked = true;
          this.loyaltySettings = res;
          this.reputationService.selectedSettings$ = this.loyaltySettings = res;
          this.reputationService.selectedReputationWallet$ = this.reputationWallet = result;
          this.nextLevel = this.authService.getUserLevelDetails(result).nextLevel;
          this.currentLevel = this.authService.getUserLevelDetails(result).currentLevel;
          this.isFinalLevel = this.authService.getUserLevelDetails(result).isFinalLevel;
          this.currentLevelPercentage = this.authService.getUserLevelDetails(result).currentLevelPercentage;
          return of(result);
        }),
      )
      .subscribe(() => this.cd.markForCheck());
  }

  getLevelPicture() {
    if (this.currentLevel) {
      return this.currentLevel.picture?.baseUrl + '/' + this.currentLevel.picture?.path;
    } else if (this.loyaltySettings?.prelevel?.picture?.baseUrl) {
      return this.loyaltySettings.prelevel.picture.baseUrl + '/' + this.loyaltySettings.prelevel.picture.path;
    } else return this.reputationPicture;
  }

  async openExternalLink(url: string) {
    Browser.open({ url });
  }

  getLevelAmount(level: ReputationWithoutTargetType, index: number): number {
    const walletAmount = +this.reputationWallet.amount;
    const reputationLevels = sortBy(this.reputationWallet.reputationLevels, 'rank');
    const min = level.levelInterval.min;
    const max = level.levelInterval.max;
    if (index === 0) {
      if (walletAmount >= min && walletAmount <= max) {
        return walletAmount;
      }
      if (walletAmount > max) {
        return max - min;
      }
    } else {
      const prevMax = reputationLevels[index - 1].levelInterval.max;
      if (walletAmount > min && walletAmount <= max) {
        return walletAmount - prevMax;
      }
      if (walletAmount > max) {
        return max - min;
      }
    }
    return 0;
  }
}
